module.exports = __webpack_public_path__ + "img/icon-outcome.9d801a8f.svg";